import { createVNode as _createVNode, isVNode as _isVNode, mergeProps as _mergeProps } from "vue";
import { defineComponent } from 'vue';
import { TableColumn as AntTableColumn } from 'ant-design-vue';
import Wrapper from '../wrapper';
import { commonProps } from '../utils';
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
const elfTableColumnProps = {
  ...commonProps
};
const tableColumnProps = {
  ...elfTableColumnProps
};
const TableColumn = defineComponent({
  name: 'ElfTableColumn',
  props: tableColumnProps,
  setup(props, {
    attrs,
    slots
  }) {
    return () => _createVNode(Wrapper, null, {
      default: () => [_createVNode(AntTableColumn, _mergeProps(props, attrs), _isSlot(slots) ? slots : {
        default: () => [slots]
      })]
    });
  }
});
export default TableColumn;